import { render, staticRenderFns } from "./InspectionViewVehicle.vue?vue&type=template&id=50c7b1e9"
import script from "./InspectionViewVehicle.vue?vue&type=script&lang=js"
export * from "./InspectionViewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports